var n = (a, i, o) => new Promise((f, s) => {
  var p = (t) => {
    try {
      e(o.next(t));
    } catch (r) {
      s(r);
    }
  }, u = (t) => {
    try {
      e(o.throw(t));
    } catch (r) {
      s(r);
    }
  }, e = (t) => t.done ? f(t.value) : Promise.resolve(t.value).then(p, u);
  e((o = o.apply(a, i)).next());
});
import { selfAxios as b } from "@oppein/op-utils";
function A(a) {
  return n(this, null, function* () {
    const {
      data: i
    } = yield b.post(
      "/bsplatform/attributeDefinition/getAttributeDataList",
      a
    );
    return i == null ? void 0 : i.data;
  });
}
export {
  A as postGetAttributeDataList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bsplatform/attributeDefinition/getAttributeDataList/post.js
// module id = 1795
// module chunks = 67